import {API} from "@/Composables/api";

const getInvitations = async (params = {}) => {
    return API.get(route("admin.invitations.index"), params);
};

const getInvitation = async (invitation: string) => {
    return API.get(route("admin.invitations.show", invitation));
};

const deleteInvitation = async (invitation: string) => {
    return API.delete(route("admin.invitations.destroy", invitation));
};

const acceptInvitation = async (invitation: string) => {
    return API.post(route("admin.invitations.accept", invitation));
};

export {getInvitations, getInvitation, deleteInvitation, acceptInvitation};
